import React, { useCallback, useEffect, useRef, useState } from 'react';

import { IntlManager } from '@atlas/core';
import { Button, HeaderTitle, Label } from '@atlas/ui';

import RenderMainStateRow from '../RenderMainStateRow';

import LimitsEdit from './LimitsEdit';

const Limits = ({
  checkCommonSpentLimit,
  checkNotCommonSpentLimit,
  limitType,
  regulationLimit,
  setRegulationLimit,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const scrollParent = useRef(null);

  const toggleEditMode = useCallback(() => {
    setIsEditMode(isEditMode => !isEditMode);
  }, [setIsEditMode]);

  useEffect(() => {
    if (!isEditMode && scrollParent.current) {
      scrollParent.current.scrollIntoView({ block: 'start' });
    }
  }, [isEditMode]);

  if (!regulationLimit) return null;

  const displayLimit = () => {
    if (isEditMode) {
      return (
        <LimitsEdit
          checkCommonSpentLimit={checkCommonSpentLimit}
          checkNotCommonSpentLimit={checkNotCommonSpentLimit}
          limitType={limitType}
          regulationLimit={regulationLimit}
          setRegulationLimit={setRegulationLimit}
          toggleEdit={toggleEditMode}
        />
      );
    }

    return regulationLimit.map(({ future, type, value }) => {
      const processedValue = IntlManager.formatMoney(value);
      const readValue = value || 0;

      return (
        <RenderMainStateRow
          future={future}
          key={type}
          prettyValue={processedValue}
          type={type}
          value={readValue}
        />
      );
    });
  };

  return (
    <div className="self-regulation__limits" ref={scrollParent}>
      <div className="title-wrapper with-button">
        <HeaderTitle className="sub-text" title={`${limitType.toLowerCase()}_limits`} />
        {!isEditMode && (
          <Button
            className="edit-limit"
            label="edit_limit"
            onClick={toggleEditMode}
            size="small"
            type="text"
          />
        )}
      </div>
      <Label
        className="description title-small-300-text"
        message={`${limitType}_self_regulation_limits_message`}
      />
      {displayLimit()}
    </div>
  );
};

export default Limits;
